"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MF = void 0;
const MFInternal_1 = require("./MFInternal");
class MF {
    internal;
    constructor(mf, options = {}) {
        this.internal = new MFInternal_1.MFInternal(mf, options);
    }
    /**
     * Returns an array of objects with kind and value that can be used to easily
     * display the molecular formula.
     */
    toDisplay() {
        return this.internal.toDisplay();
    }
    /**
     * Returns a string that represents the molecular formula adding subscript and superscript in HTML.
     */
    toHtml() {
        return this.internal.toHtml();
    }
    /**
     * Returns a string that represents the molecular formula adding subscript and superscript
     * using Unicode characters. This can not be parsed anymore so kind of dead end ...
     */
    toText() {
        return this.internal.toText();
    }
    /**
     * Similar to toText but returns a canonic string in which the atoms are sorted using the Hill system
     */
    toCanonicText() {
        return this.internal.toCanonicText();
    }
    toParts(options) {
        return this.internal.toParts(options);
    }
    /**
     * Returns an object with the global MF, global charge, monoisotopic mass and mass
     * as well as the same information for all the parts
     */
    getInfo(options) {
        return this.internal.getInfo(options);
    }
    /**
     * Returns an object with the elemental analysis
     */
    getEA() {
        return this.internal.getEA();
    }
    /**
     * Get the different elements for each part
     */
    getElements() {
        return this.internal.getElements();
    }
    /**
     * Returns an array with each atom and isotopic composition
     */
    getIsotopesInfo(options = {}) {
        return this.internal.getIsotopesInfo(options);
    }
    /**
     * Get a canonized parsable Molecule Formula
     */
    toMF() {
        return this.internal.toMF();
    }
    /**
     * Get a canonized MF
     */
    toNeutralMF() {
        return this.internal.toNeutralMF();
    }
    canonize() {
        return this.internal.canonize();
    }
    flatten(options) {
        return this.internal.flatten(options);
    }
}
exports.MF = MF;
//# sourceMappingURL=MF.js.map